import * as types from '../../action/actionTypes';
import initialState from '../initialState';
import {Identifier} from '../../components/EnsembleComponents/ReportsManagement/Identifier'
import { combineReducers } from 'redux';

function WidgetReducer(state = [], action) {
    switch(action.type) {
        case types.DELETE_REPORT_WIDGET:
            return state.filter((widget) =>
                widget.id !== action.widgetId);

        case types.CREATE_REPORT_WIDGET: 
            return [
                ...state,
                {...action.dataProps, id: action.widgetId}
            ];

        case types.UPDATE_REPORT_WIDGET:
            return state.map((widget) => 
                widget.id === action.widgetId ? { ...widget, ...action.dataProps} : widget );

        default: return state;
    }
}

function ReportDefinitionReducer(state = initialState.ReportDesigner.reportDefinition, action) {
    switch (action.type) {
        case types.GET_REPORT_DEFINITION_SUCESSFULL: {
            // recalculate hash incase checks/algorithm changes
            action.getResponse.widgets.forEach(item => {
                if (item.identifiers) {
                    for (let i of item.identifiers) {
                        Identifier.GenerateHash(i);
                    }
                }
            });
            return {
                ...action.getResponse,
            };
        }

        case types.UPDATE_REPORT_OPTIONS: {
            let page = {...state.options.page, ...action.options.page};
            return {
                    ...state,
                    options: {
                    ...state.options,
                    ...action.options,
                    page: page,
                }
            }
        }

        case types.CREATE_REPORT_DEFINITION: {
            return {
                ...initialState.ReportDesigner.reportDefinition
            }
        }

        case types.SAVE_REPORT_SUCCESSFUL: {
            return {
                ...state, id:action.getResponse.id
            }
        }

        case types.GET_IMAGE_SUCCESSFUL: {
            if (state.widgets.length > 0) { 
                let wids = state.widgets.filter(w => w.filename === action.filename);
                if (wids.length > 0) {
                    wids.forEach(function(w) {
                        w.data = action.getResponse;
                    })
                }
            }
           return {...state};
        }

        case types.UPDATE_REPORT_WIDGET: 
        case types.CREATE_REPORT_WIDGET:
        case types.DELETE_REPORT_WIDGET: {
            return {
                ...state,
                widgets: WidgetReducer(state.widgets, action)
            }
        }

        default: return state;
    }
}

function DataStoreReducer(state = initialState.ReportDesigner.dataStore, action) {
    switch (action.type) {
        case types.GET_IDENTIFIER_DATA_SUCCESSFUL: {
            let newMap = new Map(state);
            newMap.set(action.hash, action.getResponse);
            return newMap;
        }
        default: return state;
    }
}

function SaveReportDefinitionReducer(state = initialState.ReportDesigner.saveStatus, action) {
    switch (action.type) {
      case types.SAVE_REPORT_SUCCESSFUL: return {
          ...action.getResponse,
       };
       case types.SAVE_REPORT_FAILED: return {
            ...action.getResponse,
       };
       default : return state; 
    }   
}

const familyTypes = [{ id: 3, name: 'Air Handlers' }, { id: '9', name: 'Air Systems' }, { id: '11', name: 'Areas' }, { id: '2', name: 'Chillers' }, { id: '5', name: 'Chiller Plants' }, { id: '6', name: 'Heat Pump Loops' }, { id: '7', name: 'Points' }, { id: '4', name: 'Programmable Controllers' }, { id: '1', name: 'Spaces' }, { id: '13', name: 'Trim/Respond' }]

function DatalogReducer(state = initialState.ReportDesigner.dataSource.datalog, action) {
    if (action.dataSourceType === 'datalog') {
        switch(action.type) {
            case types.GET_BUILDINGS_SUCCESSFUL: {
                let bldg = {...state.building};
                return {
                    ...state, building: {...bldg, list: action.getResponse}
                };
            }
            case types.GET_FAMILYTYPES_SUCCESSFUL: {
                let rtn = {...state.familytype};
                return {
                    ...state, familytype: {...rtn, list: familyTypes}
                };
            }
            case types.GET_OBJECTS_SUCCESSFUL: {
                let rtn = {...state.object};
                return {
                    ...state, object: {...rtn, list: action.getResponse}
                };
            }
            case types.GET_POINTS_SUCCESSFUL: {
                let rtn = {...state.point};
                return {
                    ...state, point: {...rtn, list: action.getResponse}
                };
            }
            case types.GET_DATALOG_SUCCESSFUL: {
                let rtn = {...state.datalog};
                return {
                    ...state, datalog: {...rtn, list: state.point.list.filter(x => x.displayName === action.displayName)}
                };
            }
            case types.SET_DATASOURCE_SELECTIONS: {
                return {
                    ...state, building: action.building, familytype: action.familytype, object: action.object, point: action.point, datalog: action.datalog
                }
            }
            default: return state;
        }
    }
    return state;
}

function NormalizedReducer(state = initialState.ReportDesigner.dataSource.normalized, action) {
    if (action.dataSourceType === 'normalization') {
        switch(action.type) {
            case types.GET_BUILDINGS_SUCCESSFUL: {
                let bldg = {...state.building};
                return {
                    ...state, building: {...bldg, list: action.getResponse}
                };
            }
            case types.GET_FAMILYTYPES_SUCCESSFUL: {
                let rtn = {...state.familytype};
                return {
                    ...state, familytype: {...rtn, list: familyTypes}
                };
            }
            case types.GET_OBJECTS_SUCCESSFUL: {
                let rtn = {...state.object};
                return {
                    ...state, object: {...rtn, list: action.getResponse}
                };
            }
            case types.GET_POINTS_SUCCESSFUL: {
                let rtn = {...state.point};
                return {
                    ...state, point: {...rtn, list: action.getResponse}
                };
            }
            case types.GET_DATALOG_SUCCESSFUL: {
                let rtn = {...state.datalog};
                return {
                    ...state, datalog: {...rtn, list: state.point.list.filter(x => x.displayName === action.displayName)}
                };
            }
            case types.SET_DATASOURCE_SELECTIONS: {
                return {
                    ...state, building: action.building, familytype: action.familytype, object: action.object, point: action.point, datalog: action.datalog
                }
            }
            default: return state;
        }
    }
    return state;
}

function DatasourceTypeReducer(state = 'datalog', action) {
    if (action.dataSourceType)
        return action.dataSourceType;
    return state;
}

let DataSourceReducer = combineReducers({
    datalog: DatalogReducer,
    dataSourceType: DatasourceTypeReducer,
    normalized: NormalizedReducer
});

export default combineReducers({
    reportDefinition: ReportDefinitionReducer,
    dataStore: DataStoreReducer,
    saveStatus: SaveReportDefinitionReducer,
    dataSource: DataSourceReducer,
});